import type { Store } from 'pinia'
import { defineStore } from 'pinia'

// eslint-disable-next-line import/no-named-default
import { default as currency } from 'currency.js'
import type { CanvasSchemaData, EntranceSchemaData } from '@/types'
const { moneyFormater } = useMoneyFormater()

type CartEntry = CanvasSchemaData | EntranceSchemaData

type Cart = CanvasSchemaData[] | Record<string, EntranceSchemaData>

type State = {
  event: string
  cart: Cart
  user: {
    email: string
    firstName: string
    secondName: string
    phone: string
  }
}

type Getters = {
  cartAmount: string
  commissionAmount: Function
  // (commission: number): string
}

type Actions = {
  clearStore: () => void
  setCart: (value: Cart) => void
  addToCart: (value: CartEntry) => void
  removeFromCart: (params: CartEntry) => void
  clearCart: () => void
  setUserEmail: (value: string) => void
  setUserFirstName: (value: string) => void
  setUserSecondName: (value: string) => void
  setUserPhone: (value: string) => void
  setEvent: (value: string) => void
}

export const useOrderStore: () => Store<'order-store', State, Getters, Actions> = defineStore({
  id: 'order-store',
  state: () => ({
    event: '',
    cart: [],
    user: {
      email: '',
      firstName: '',
      secondName: '',
      phone: ''
    }
  }),
  actions: {
    clearStore() {
      this.event = ''
      this.cart = []
      this.user = {
        email: '',
        firstName: '',
        secondName: '',
        phone: ''
      }
    },
    setCart(value) {
      this.cart = value
    },
    addToCart(value) {
      this.cart.push(value)
    },
    removeFromCart(params) {
      this.cart.forEach((ticket, index) => {
        if (ticket.ID === params.ID) {
          this.cart.splice(index, 1)
        }
      })
    },
    clearCart() {
      this.cart = []
      this.user = {
        email: '',
        firstName: '',
        secondName: '',
        phone: ''
      }
      this.event =''
    },
    setUserEmail(value) {
      this.user.email = value
    },
    setUserFirstName(value) {
      this.user.firstName = value
    },
    setUserSecondName(value) {
      this.user.secondName = value
    },
    setUserPhone(value) {
      this.user.phone = value
    },
    setEvent(value) {
      this.event = value
    }
  },
  getters: {
    cartAmount(): string {
      return this.cart.reduce(
        (amount, entry): string =>
          (amount = currency(Number(amount)).add(Number(entry.Price)).toString()),
        '0.00'
      )
    },
    commissionAmount(): (commission: number) => string {
      return (commission: number) => {
        return currency(this.cartAmount).multiply(commission).divide(100).toString()
      }
    }
  }
})
